<template>
  <div>
    <b-input
      v-model="routeCredentials.name"
      label="Назва"
      :error-messages="getErrorMessages(v$.name)"
      placeholder="веддіть назву маршрута"
      @blur="v$.name.$touch()"></b-input>

    <div class="font-weight-bold font-size-15">Режим маршруту погодження</div>
    <div class="text-disabled mb-3">
      Визначте умови дотримання маршруту документа
    </div>
    <v-radio-group
      v-model="routeCredentials.typeId"
      :loading="$loading.isLoading('docTypeRouteTypes')"
      :error-messages="getErrorMessages(v$.typeId)"
      @blur="v$.typeId.$touch()">
      <v-row>
        <v-col
          v-for="item in $directory.get('docTypeRouteTypes')"
          :key="item.id"
          cols="6">
          <radio-card
            class="h-100"
            :title="item.name"
            :subtitle="item.description"
            :is-active="routeCredentials.typeId === item.id"
            :value="item.id"></radio-card>
        </v-col>
      </v-row>
    </v-radio-group>
  </div>
</template>

<script lang="ts">
import { Dialog } from '@/dialog'
import { PropType, reactive } from 'vue'
import { DocumentTypeRouteCredentials } from '@/utils/types/documentRoute'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { docTypeRouteCreate, docTypeRouteUpdate } from '@/requests/documentType'
import { omit } from 'lodash'
import { getErrorMessages } from 'best-modules/utils'
import { fillDirectory } from '@/directory'
import RadioCard from '@/components/RadioCard.vue'

export default {
  name: 'DocTypeRoute',
  components: { RadioCard },
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    fillDirectory('docTypeRouteTypes')
    const routeCredentials = reactive<DocumentTypeRouteCredentials>({
      docTypeDefinitionId: props.dialog.dialogData.route.docTypeDefinitionId,
      name: null as any,
      typeId: 1,
    })
    const rules = {
      name: { required },
      typeId: { required },
    }
    const v$ = useVuelidate(rules, routeCredentials)

    if (props.dialog.action === 'create') {
      fillDirectory('docTypeRouteTypes')
    } else {
      Object.assign(routeCredentials, props.dialog.dialogData.route)
    }

    const submit = () => {
      if (props.dialog.action === 'create') {
        return docTypeRouteCreate(routeCredentials)
      } else {
        return docTypeRouteUpdate(
          props.dialog.dialogData.route.id,
          omit(routeCredentials, 'docTypeDefinitionId')
        )
      }
    }

    return {
      routeCredentials,
      v$,
      submit,
    }
  },
}
</script>
